<template>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
           :src="getLogo()"
          transition="scale-transition"
          width="40"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="100"
           :src="getTitle()"
          width="200"
        />
      </div>

      <v-btn class="ml-12" text @click="$emit('setAnalytics', 'events')">
        <span class="mr-2">Events</span>
        <!-- <v-icon>mdi-open-in-new</v-icon> -->
      </v-btn>

      <v-btn text @click="$emit('setAnalytics', 'jobs')">
        <span class="mr-2">Jobs</span>
        <!-- <v-icon>mdi-open-in-new</v-icon> -->
      </v-btn>

      <v-btn text @click="$emit('setAnalytics', 'contacts')">
        <span class="mr-2">Contacts</span>
        <!-- <v-icon>mdi-open-in-new</v-icon> -->
      </v-btn>

      <v-spacer></v-spacer>
      
      <div v-show="username" class="transparent">
        <span class="font-weight-light" >Hello {{username}}</span>
      </div>

      <v-btn target="_blank" text @click="testPrivate" >
        <span class="mr-2">Test</span>
        <!-- <v-icon>mdi-open-in-new</v-icon> -->
      </v-btn>

      <v-btn v-show="username" target="_blank" text @click="$emit('callLogout')" >
        <span class="mr-2">Logout</span>
        <!-- <v-icon>mdi-open-in-new</v-icon> -->
      </v-btn>

    </v-app-bar>
</template>

<script>
  export default {
    name: 'Header',
    props: ['username'],
    data: () => ({
      menu: [
        {title: 'Invite'},
        {title: 'Change Password'},
        {title: 'Logout'},
      ]


    }),
    computed: {
        getLogoUrl: function() {
            return this.getHost() + "content/site_logo.png";
        }
    },
    methods: {
        getLogo() {
            return this.getHost() + "/content/site_logo.png";
        },
        getTitle() {
            return this.getHost() + "/content/site_title.png";
        },
      testPrivate() {
        this.$http
        .get(this.getHost() + 'admin/private')
        .then(response => {
            console.log(response);
        }, error => {
          console.log("Private failed ");
          console.log(error);
        });
        this.$http
        .get(this.getHost() + 'admin/public')
        .then(response => {
            console.log(response);
        }, error => {
          console.log("Public failed ");
          console.log(error);
        });
      },
      menuClick() {

      }
    }
  }
</script>
